import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { DriverIsOutOfServiceRequestDto, ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class UpdateDriverIsOutOfServiceCommand extends IRequestCommand<
  IUpdateDriverIsOutOfServiceCommand,
  ErrorDetails,
  IUpdateDriverIsOutOfServiceCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carriers/{carrierUserId}/drivers/{driverUserId}/outOfService';

  override setParameters(parameters: IUpdateDriverIsOutOfServiceCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{driverUserId}',
      parameters.driverUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandBody = parameters;
  }
}

export interface IUpdateDriverIsOutOfServiceCommandParameters
  extends DriverIsOutOfServiceRequestDto,
    ICommandParameters {}

export interface IUpdateDriverIsOutOfServiceCommand extends ICommandResponse {}
